import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';

import Select from './Select';
import SelectOption from './SelectOption';

import { COUNTRIES, NORTH_AMERICA_COUNTRIES } from '../../../constants';

export default class CountryPicker extends React.PureComponent {
    static propTypes = {
        /** html id required to connect the select with the label */
        id: PropTypes.string.isRequired,

        /** Label contents, usually text */
        label: PropTypes.node,

        /** Text of placeholder */
        placeholder: PropTypes.string
    };

    static defaultProps = {
        label: 'Country',
        placeholder: 'Choose a country ...'
    };

    constructor(props) {
        super(props);

        this.countryOptions = COUNTRIES.sort((a, b) => {
            if (a.label < b.label) {
                return -1
            }
            else if (a.label > b.label) {
                return 1
            }
            return 0;
        });

        this.selectRef = React.createRef();
    }

    validate = () => {
        return this.selectRef.current.validate();
    }

    render() {
        const { label, id, ...rest } = this.props;
        const props = omit(rest, [
            'ref'
        ]);

        return (
            <Select
                ref={this.selectRef}
                label={label}
                id={id}
                {...props} >
                {NORTH_AMERICA_COUNTRIES.map((option) => (
                    <SelectOption
                        key={option.value}
                        value={option.value}>
                        {option.label}
                    </SelectOption>
                ))}

                <SelectOption value="divider" isDisabled>──────────────────</SelectOption>

                {this.countryOptions.map((option) => (
                    <SelectOption
                        key={option.value}
                        value={option.value}>
                        {option.label}
                    </SelectOption>
                ))}
            </Select>
        );
    }
}
